import { useMemo } from 'react';
import useLocalStorage from 'ui-forms-components/utils/useLocalStorage';
const useDismissible = (localStorageKey, daysToReappear = 99999) => {
  const [timestamp, setTimestamp] = useLocalStorage({
    key: localStorageKey
  });
  const shouldBeShown = useMemo(() => !Number(timestamp) || Number(timestamp) < Date.now().valueOf(), [timestamp]);
  const updateLocalStorageKey = () => {
    const inDaysToReappear = new Date();
    inDaysToReappear.setUTCDate(inDaysToReappear.getUTCDate() + daysToReappear);
    setTimestamp(inDaysToReappear.valueOf());
  };
  return [shouldBeShown, updateLocalStorageKey];
};
export default useDismissible;